import { about, about2, about3, blog1, blog2, blog3, logo, project1, project2, project3, project4, project5, servive1, servive2, servive3, slider1, user1, user2, user3, user4, } from "../images"
import { commets } from "./inventory"

const videoUrl = 'https://player.vimeo.com/external/371592662.sd.mp4?s=ba0c453a1cb4787d897e61bc63ab9567e18f7da0&profile_id=164&oauth2_token_id=57447761'
export const primary = '#d00104'
export const secondary = '#ff4d00'
export const SECTION_HEIGHT = 1500;
const blogData = [
   {
      id: '1',
      title: 'Digital Marketing: Staying Relevant To The Empowered Consumer',
      descrition: '',
      image: blog1,
      author: 'Reinaldo Vombo',
      category: ['Psicologia', 'Agencia', 'Parceria'],
      comment: commets
   },
   {
      id: '2',
      title: 'Grow Your Business With A Digital Marketing Strategy',
      descrition: '',
      image: blog2,
      author: 'Reinaldo Vombo',
      category: ['Psicologia', 'Agencia', 'Marketing digital'],
      comment: commets
   },
   {
      id: '3',
      title: '5 Inexpensive Online Tools To Get Your Business Off The Ground',
      descrition: '',
      image: blog3,
      author: 'Reinaldo Vombo',
      category: ['SEO orgânico de longo prazo', 'Agencia', 'Parceria', 'Contacto'],
      comment: commets
   },
]
export const APIDATA: [] = []

export const LOCAL_DATA = {
   logotype: logo,
   siteMenu: ['Home', 'Sobre', 'Portfolio', 'Eventos', 'Blogs', 'Membros', 'Servicos', 'Testimonial', 'Contacto'],
   siteColor: { primary: '#d00104', secondary: '#ff4d00' },
   headerBanner: [slider1, about2, about3],
   headerSection: {
      title: 'Somos especialistas em marketing digital',
      subTitle: 'CANDIDATURAS ABERTAS!',
      description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta doloribus, ab distinctio, a ullam non culpa quos, voluptatum commodi perspiciatis amet magni architecto ad? Ullam iusto tempore odit ratione praesentium?',
   },
   about: [
      {
         thumbnail: ["https://antfu.me/assets/p-2024-10-27-08-02-17-000-1-DOunZRrr.jpg"],
         title: 'Sobre Nós',
         subTitle: 'EMPREENDEDORISMO COM PROPÓSITO',
         description: 'O FILuanda forma parte da Rede Global do Founder Institute; uma incubadora de empresas americana, sediada em Silicom Valley, de formação empresarial com um programa de lançamento de startups fundado na Califórnia em 2009. A Rede do Founder Institute está presente em mais de 180 cidades em todo o mundo. Em África, em 10 países; África do Sul, Burquina Faso, Congo Demócratico, Egipto, Ghana, Kenya, Namibia, Nigeria e Tunisia. Nos países de expressão portuguesa existem Chapters em Lisboa e Brazil. O Founder Institute tem ajudado a lançar mais de 4.500 empresas em seis continentes.',

      },
      {
         thumbnail: ["https://antfu.me/assets/p-2019-04-22-08-31-33-000-1-B6RONCMn.jpg"],
         title: 'Sobre Nós',
         subTitle: 'EMPREENDEDORISMO COM PROPÓSITO',
         description: 'O FILuanda forma parte da Rede Global do Founder Institute; uma incubadora de empresas americana, sediada em Silicom Valley, de formação empresarial com um programa de lançamento de startups fundado na Califórnia em 2009. A Rede do Founder Institute está presente em mais de 180 cidades em todo o mundo. Em África, em 10 países; África do Sul, Burquina Faso, Congo Demócratico, Egipto, Ghana, Kenya, Namibia, Nigeria e Tunisia. Nos países de expressão portuguesa existem Chapters em Lisboa e Brazil. O Founder Institute tem ajudado a lançar mais de 4.500 empresas em seis continentes.',

      },

   ],
   services: [
      {
         _id: '1',
         thumbnail: [],
         title: 'Nosso serviços',
         subTitle: 'SERVIÇOS PARA O SEU NÉGOCIO',
         description: 'Nossos Serviços resolvem Qualquer problema',
      },
      {
         _id: '2',
         thumbnail: [servive1],
         title: 'Modern Website Design',
         subTitle: 'Lorem ipsum dolor sit amet, consectetu adipiscing elit, sed do eiusmod tempory maecenas accumsan lacus facilisis.',
         description: 'Nossos Serviços resolvem Qualquer problema',
      },
      {
         _id: '3',
         thumbnail: [servive2],
         title: 'SEO And Content Writing',
         subTitle: 'Lorem ipsum dolor sit amet, consectetu adipiscing elit, sed do eiusmod tempory maecenas accumsan lacus facilisis.',
         description: 'Nossos Serviços resolvem Qualquer problema',
      },
      {
         _id: '4',
         thumbnail: [servive3],
         title: 'App Development',
         subTitle: 'Lorem ipsum dolor sit amet, consectetu adipiscing elit, sed do eiusmod tempory maecenas accumsan lacus facilisis.',
         description: 'Nossos Serviços resolvem Qualquer problema',
      },
      {
         _id: '5',
         thumbnail: [videoUrl],
         title: 'We Are Digital Marketing Expert',
         subTitle: 'CANDIDATURAS ABERTAS!',
         description: 'O FILuanda forma parte da Rede Global do Founder Institute; uma incubadora de empresas americana, sediada em Silicom Valley, de formação empresarial com um programa de lançamento de startups fundado na Califórnia em 2009. A Rede do Founder Institute está presente em mais de 180 cidades em todo o mundo. Em África, em 10 países; África do Sul, Burquina Faso, Congo Demócratico, Egipto, Ghana, Kenya, Namibia, Nigeria e Tunisia. Nos países de expressão portuguesa existem Chapters em Lisboa e Brazil. O Founder Institute tem ajudado a lançar mais de 4.500 empresas em seis continentes.',
      },
   ],
   portfolio: [
      {
         id: '1',
         thumbnail: [],
         title: 'Nosso projectos',
         subTitle: 'DESCUBRA O MUNDO DE NÉGOCIO',
         description: '',
         url: '',
      },
      {
         id: '2',
         thumbnail: [project1],
         title: 'Modern Website Design',
         subTitle: '',
         description: 'Lorem ipsum dolor sit amet, consectetu adipiscing elit, sed do eiusmod tempory maecenas accumsan lacus facilisis.',
         url: '',
      },
      {
         id: '3',
         thumbnail: [project2],
         title: 'SEO And Content Writing',
         subTitle: '',
         description: 'Lorem ipsum dolor sit amet, consectetu adipiscing elit, sed do eiusmod tempory maecenas accumsan lacus facilisis.',
         url: '',
      },
      {
         id: '4',
         thumbnail: [project3],
         title: 'App Development',
         subTitle: '',
         description: 'Lorem ipsum dolor sit amet, consectetu adipiscing elit, sed do eiusmod tempory maecenas accumsan lacus facilisis.',
         url: '',
      },
      {
         id: '5',
         thumbnail: [project4],
         title: 'App Development',
         subTitle: '',
         description: 'Lorem ipsum dolor sit amet, consectetu adipiscing elit, sed do eiusmod tempory maecenas accumsan lacus facilisis.',
         url: '',
      },
      {
         id: '6',
         thumbnail: [project5],
         title: 'App Development',
         subTitle: '',
         description: 'Lorem ipsum dolor sit amet, consectetu adipiscing elit, sed do eiusmod tempory maecenas accumsan lacus facilisis.',
         url: '',
      },
   ],

   testimonial: [
      {
         photo: "https://images.unsplash.com/photo-1547425260-76bcadfb4f2c?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
         name: 'Jonas da silva',
         position: 'CEO',
         message: 'Lorem ipsum dolor sit amet, consectetu adipiscing elit, sed do eiusmod tempory maecenas accumsan lacus facilisis',
      },
      {
         photo: "https://images.unsplash.com/flagged/photo-1570612861542-284f4c12e75f?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8cGVzc29hfGVufDB8fDB8fHww",
         name: 'Sergio da silva',
         position: 'CEO',
         message: 'Lorem ipsum dolor sit amet, consectetu adipiscing elit, sed do eiusmod tempory maecenas accumsan lacus facilisis',
      },
      {
         photo: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8cGVzc29hfGVufDB8fDB8fHww",
         name: 'Olga Marcia',
         position: 'CEO',
         message: 'Lorem ipsum dolor sit amet, consectetu adipiscing elit, sed do eiusmod tempory maecenas accumsan lacus facilisis',
      },
   ],
   team: [
      {
         _id: '1',
         thumbnail: user1,
         name: 'Jonh doe',
         jobPosition: 'CEO',
      },
      {
         _id: '2',
         thumbnail: user2,
         name: 'Jonh doe',
         jobPosition: 'Gerente de Operações',
      },
      {
         _id: '3',
         thumbnail: user3,
         name: 'Jonh doe',
         jobPosition: 'Chefe de Finanças',
      },
      {
         _id: '3',
         thumbnail: user4,
         name: 'Jonh doe',
         jobPosition: 'Chefe de Finanças',
      },
   ],
   colores: {
      primary: "#d00104",
      secondary: "#ff4d00",
      sucesse: "",
      danger: ""
   },
   blogPosts: [
      {
         _id: '1',
         title: "Getting Started with Web Development",
         author: 'Armando Silva',
         draft: false,
         description: "Learn the fundamentals of HTML, CSS, and JavaScript to kickstart your web development journey.",
         date: "April 10, 2025",
         slug: "getting-started-with-web-development",
         thumbnail: project1,
         category: 'Agencia',
         start: new Date(),
         end: new Date(),
         createdAt: new Date(),
         updatedAt: new Date(),
         content: "<p>Web development is an exciting field that combines creativity with technical skills. If you're just starting out, it might seem overwhelming, but with the right approach, you can quickly get up to speed.</p><h2>The Three Core Technologies</h2>"
      },
      {
         _id: '2',
         title: "Mastering React Hooks",
         author: 'Armando Silva',
         draft: false,
         description: "Dive deep into React Hooks and learn how to build more efficient and cleaner React components.",
         date: "April 5, 2025",
         slug: "mastering-react-hooks",
         thumbnail: project2,
         category: 'Analise',
         start: new Date(),
         end: new Date(),
         createdAt: new Date(),
         updatedAt: new Date(),
         content: "<p>Web development is an exciting field that combines creativity with technical skills. If you're just starting out, it might seem overwhelming, but with the right approach, you can quickly get up to speed.</p><h2>The Three Core Technologies</h2>"
      },
      {
         _id: '3',
         title: "The Future of AI in Web Development",
         author: 'Armando Silva',
         draft: false,
         description: "Explore how artificial intelligence is transforming the landscape of modern web development.",
         date: "March 28, 2025",
         slug: "future-of-ai-in-web-development",
         thumbnail: project4,
         category: 'Gestoria',
         start: new Date(),
         end: new Date(),
         createdAt: new Date(),
         updatedAt: new Date(),
         content: "<p>Web development is an exciting field that combines creativity with technical skills. If you're just starting out, it might seem overwhelming, but with the right approach, you can quickly get up to speed.</p><h2>The Three Core Technologies</h2>"
      },
      {
         _id: '4',
         title: "Building Responsive Layouts with Tailwind CSS",
         author: 'Marcelo Ribeiro',
         draft: false,
         description:
            "Learn how to create beautiful, responsive designs quickly using the utility-first approach of Tailwind CSS.",
         date: "March 20, 2025",
         slug: "responsive-layouts-with-tailwind",
         thumbnail: project3,
         category: 'Agencia',
         start: new Date(),
         end: new Date(),
         createdAt: new Date(),
         updatedAt: new Date(),
         content: "<p>Web development is an exciting field that combines creativity with technical skills. If you're just starting out, it might seem overwhelming, but with the right approach, you can quickly get up to speed.</p><h2>The Three Core Technologies</h2>"
      },
   ],
   eventes: [
      {
         _id: '1',
         thumbnail: 'https://images.unsplash.com/photo-1507208773393-40d9fc670acf?q=80&amp;w=2787&amp;auto=format&amp;fit=crop&amp;ixlib=rb-4.0.3&amp;ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
         author: 'Armando Silva',
         draft: false,
         slug: 'digital-marketing-staying-relevant-to-the-empowered-consumer',
         title: 'Digital Marketing: Staying Relevant To The Empowered Consumer',
         subTitle: 'Lorem ipsum dolor sit amet, consectetu adipiscing elit, sed do eiusmod tempory maecenas accumsan lacus facilisis.',
         description: 'Lorem ipsum dolor sit amet, consectetu adipiscing elit, sed do eiusmod tempory maecenas accumsan lacus facilisis.',
         category: 'Agencia',
         start: new Date(),
         end: new Date(),
         createdAt: new Date(),
         updatedAt: new Date(),
         content: "<p>Web development is an exciting field that combines creativity with technical skills. If you're just starting out, it might seem overwhelming, but with the right approach, you can quickly get up to speed.</p><h2>The Three Core Technologies</h2>"
      },
      {
         _id: '2',
         thumbnail: "https://images.unsplash.com/photo-1535957998253-26ae1ef29506?q=80&amp;w=2836&amp;auto=format&amp;fit=crop&amp;ixlib=rb-4.0.3&amp;ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
         title: 'Grow Your Business With A Digital Marketing Strategy',
         slug: 'grow-your-business-with-a-digital-marketing-strategy',
         author: 'Paulo da Costa',
         draft: false,
         subTitle: 'Lorem ipsum dolor sit amet, consectetu adipiscing elit, sed do eiusmod tempory maecenas accumsan lacus facilisis.',
         description: 'Lorem ipsum dolor sit amet, consectetu adipiscing elit, sed do eiusmod tempory maecenas accumsan lacus facilisis.',
         category: 'Marketing',
         start: new Date(),
         end: new Date(),
         createdAt: new Date(),
         updatedAt: new Date(),
         content: "<p>Web development is an exciting field that combines creativity with technical skills. If you're just starting out, it might seem overwhelming, but with the right approach, you can quickly get up to speed.</p><h2>The Three Core Technologies</h2>"

      },
      {
         _id: '3',
         thumbnail: "https://images.unsplash.com/photo-1521649415036-659258dc424f?q=80&amp;w=2548&amp;auto=format&amp;fit=crop&amp;ixlib=rb-4.0.3&amp;ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
         title: '5 Inexpensive Online Tools To Get Your Business Off The Ground',
         slug: '5-inexpensive-online-tools-to-get-your-business-off-the-ground',
         author: 'Maria Silva',
         draft: false,
         subTitle: 'Lorem ipsum dolor sit amet, consectetu adipiscing elit, sed do eiusmod tempory maecenas accumsan lacus facilisis.',
         description: 'Lorem ipsum dolor sit amet, consectetu adipiscing elit, sed do eiusmod tempory maecenas accumsan lacus facilisis.',
         category: 'SEO orgânico de longo prazo',
         start: new Date(),
         end: new Date(),
         createdAt: new Date(),
         updatedAt: new Date(),
         content: "<p>Web development is an exciting field that combines creativity with technical skills. If you're just starting out, it might seem overwhelming, but with the right approach, you can quickly get up to speed.</p><h2>The Three Core Technologies</h2>"

      },
      {
         _id: '4',
         thumbnail: "https://images.unsplash.com/photo-1742836531275-1819edd83c46?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
         title: '6 Inexpensive Tools To Get Your Business Off The Ground',
         slug: '6-inexpensive-tools-to-get-your-business-off-the-ground',
         author: 'Maria Silva',
         draft: true,
         subTitle: 'Lorem ipsum dolor sit amet, consectetu adipiscing elit, sed do eiusmod tempory maecenas accumsan lacus facilisis.',
         description: 'Lorem ipsum dolor sit amet, consectetu adipiscing elit, sed do eiusmod tempory maecenas accumsan lacus facilisis.',
         category: 'SEO orgânico de longo prazo',
         start: new Date(),
         end: new Date(),
         createdAt: new Date(),
         updatedAt: new Date(),
         content: "<p>Web development is an exciting field that combines creativity with technical skills. If you're just starting out, it might seem overwhelming, but with the right approach, you can quickly get up to speed.</p><h2>The Three Core Technologies</h2>"
      },
   ],
   contact: {
      phone: ['(+244)912 345 6789', '(+244)912 345 6789'],
      whatsapp: 'https://web.whatsapp.com',
      facebook: 'https://www.facebook.com',
      twitter: 'https://x.com/home',
      linkedIn: 'https://www.linkedin.com',
      instagram: '',
      email: ['info@exemol'],
      youtube: 'https://www.youtube.com/',
      address: '5919 Trussville St, Birmingham, America',
   },
   footer: {
      logo: logo,
      descrition: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Doloribus, perferendis. Amet sit sed, minima odio quis similique, tenetur molestias eum reiciendis vitae doloremque adipisci placeat, id aperiam unde sequi ea.',
      event: 'EVENTOS RECENTES',
      events: blogData
   }


}


